<script>
	import SvgMaskTile from './SvgMaskTile.svelte'

	export let maskId = ("id" +Math.random()).replace(".", "")

	export let rows = []
	export let cols = []
	export let items = []

	const totalWidth=1
	const totalHeight=1

	const numberOfRows = 28
	const numberOfColumns =28
	
	const tileWidth=totalWidth/numberOfColumns
	const tileHeight=totalHeight/numberOfRows

	const getItem = (col, row) => {
		return items.find(item => item.row === row && item.col === col)
	}

	const getIslandBounds = (island) => {
		let minRow = island.reduce((min, i) => i.row < min ? i.row : min, island[0].row)
		let maxRow = island.reduce((max, i) => i.row > max ? i.row : max, island[0].row)
		let minCol = island.reduce((min, i) => i.col < min ? i.col : min, island[0].col)
		let maxCol = island.reduce((max, i) => i.col > max ? i.col : max, island[0].col)
		return {
			minRow,
			maxRow,
			minCol,
			maxCol
		}
	}

	$: bounds = getIslandBounds(items)
	$: console.log(bounds)

</script>

<div class="container">
	<div class="mask" style="--maskUrl: url(#{maskId});">
		<div class="media-container" style="
			left: {bounds.minCol * tileWidth * 100}%;
			top: {bounds.minRow * tileHeight * 100}%;
			width: {(bounds.maxCol - bounds.minCol + 1) * 100 * tileWidth}%;
			height: {(bounds.maxRow - bounds.minRow + 1) * 100 * tileHeight}%;
			"
		>
			<slot />
		</div>
	</div>

	<svg width={totalWidth} height={totalHeight}>
		<defs>
			<clipPath id={maskId} clipPathUnits="objectBoundingBox">
				{#each rows as row, rowIndex}
						{#each cols as col, colIndex}
							<SvgMaskTile {colIndex} {rowIndex} {tileWidth} {tileHeight} item={ getItem(colIndex, rowIndex) }/>
						{/each}
				{/each}
			</clipPath>
		</defs>
	</svg>
</div>

<style>
	svg {
		position: absolute;
		z-index: -1;
	}

	.container {
		/* background-color: blue; */
		width: 100%;
		height: 100%;
		position: relative;
	}

	.mask {
		-webkit-clip-path: var(--maskUrl);
		clip-path: var(--maskUrl);
		width: 100%;
		height: 100%;
		/* background-color: yellow; */
	}

	.media-container {
		position: absolute;
		/* background-color: red; */
	}

</style>